module.exports = __webpack_public_path__ + "static/media/FPShorizontal.4591db6f.pdf";